module.exports = __webpack_public_path__ + "img/edit.512ba90f.svg";